import React from 'react';
import AdminAgentsComp from '../../components/AdminAgentsComp';

function AdminPendingAgents({ token }) {
  // Show only pending agents waiting for activation
  return <AdminAgentsComp token={token} filterByStatus="pending" pageTitle="Pending Agents" />
}

export default AdminPendingAgents;
